// /* eslint-disable @nx/enforce-module-boundaries */
import { inputAnatomy } from '@chakra-ui/anatomy';
import { ComponentStyleConfig } from '@chakra-ui/react';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { theme as defaultTheme } from '@chakra-ui/theme';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  inputAnatomy.keys
);

const republicInputBaseStyles = {
  border: '1px solid',
  borderColor: 'grey.400',
  borderRadius: 'lg',
  height: '10',
  bg: 'white',
  _hover: {
    borderColor: 'blue.300',
  },
  _focusVisible: {
    borderColor: 'blue.500',
    boxShadow: '0 0 2px 2px rgb(85 85 85 / 5%)',
  },
  _placeholder: {
    color: 'grey.400',
  },
  _invalid: {
    borderColor: 'red.500',
    _hover: {
      borderColor: 'red.500',
    },
    _focusVisible: {
      borderColor: 'blue.500',
    },
  },
  _disabled: {
    borderColor: 'grey.300',
    bg: 'grey.50',
    _hover: {
      borderColor: 'grey.300',
    },
  },
};

export const Input: ComponentStyleConfig = defineMultiStyleConfig({
  sizes: {
    default: {
      field: {
        height: '12',
        width: '100%',
        border: '0.1',
        borderRadius: 'lg',
        borderColor: 'grey.400',
        bg: 'white',
        py: '3',
        px: '4',
      },
    },
  },

  variants: {
    'republic-default': {
      field: { ...republicInputBaseStyles },
    },
    'republic-outline-large': (props: StyleFunctionProps) => ({
      ...defaultTheme.components.Input.variants?.outline(props),
      field: {
        ...defaultTheme.components.Input.variants?.outline(props).field,
        ...defaultTheme.components.Input.sizes?.lg.field,
        ...republicInputBaseStyles,
        fontSize: '26px',
        border: '2px solid',
        _hover: {
          ...republicInputBaseStyles['_hover'],
          boxShadow: '0 4px 20px rgb(0 0 0 / 10%)',
        },
        _focusVisible: {
          ...republicInputBaseStyles['_focusVisible'],
          border: '2px solid',
          boxShadow: '0 4px 20px rgb(0 0 0 / 10%)',
        },
        py: '3',
        fontWeight: 'light',
        height: '14',
      },
    }),
    'republic-outline': (props: StyleFunctionProps) => ({
      ...defaultTheme.components.Input.variants?.outline(props),
      field: {
        ...defaultTheme.components.Input.variants?.outline(props).field,
        ...defaultTheme.components.Input.sizes?.lg.field,
        ...republicInputBaseStyles,
        height: '10',
      },
    }),
    'republic-outline-small': (props: StyleFunctionProps) => ({
      ...defaultTheme.components.Input.variants?.outline(props),
      field: {
        ...defaultTheme.components.Input.variants?.outline(props).field,
        ...defaultTheme.components.Input.sizes?.md.field,
        ...republicInputBaseStyles,
        height: '9',
      },
    }),
    'republic-outline-lite': (_props: StyleFunctionProps) => ({
      // Note (deprecated - DLS migration):
      // `republic-outline-lite` now matches the default variant
      field: { ...republicInputBaseStyles },
    }),
  },
  defaultProps: {
    variant: 'republic-default',
    size: 'default',
  },
});
